// store/modules/config.js
import { getWebViewConfig } from '@/api/config'
import { getWebConfig, isWebConfigChanged, setWebConfig } from '@/utils/config'

const state = {
    webViewConfig: null
}

const mutations = {
    SET_WEB_VIEW_CONFIG(state, config) {
        state.webViewConfig = config
    }
}

const actions = {
    async getWebViewConfig({ commit }) {
        try {
            const response = await getWebViewConfig()
            setWebConfig(response.data)
            commit('SET_WEB_VIEW_CONFIG', response.data)
            return response
        } catch (error) {
            console.error('获取网站设置失败:', error)
            throw error
        }
    },

    // 启动时：先用缓存（秒开），再后台拉新比对是否需要更新
    async bootstrapWebViewConfig({ commit, dispatch }) {
        const cached = getWebConfig()
        if (cached) commit('SET_WEB_VIEW_CONFIG', cached)

        // 后台刷新：有变化才更新缓存与store
        try {
            const response = await dispatch('refreshWebViewConfigIfNeeded')
            return { cachedUsed: !!cached, ...response }
        } catch (e) {
            return { cachedUsed: !!cached, updated: false, error: e }
        }
    },

    async refreshWebViewConfigIfNeeded({ commit }) {
        const oldConfig = getWebConfig()
        const response = await getWebViewConfig({ force: true })
        const newConfig = response.data

        const changed = isWebConfigChanged(oldConfig, newConfig)
        if (changed) {
            setWebConfig(newConfig)
            commit('SET_WEB_VIEW_CONFIG', newConfig)

            // 给站点一个“配置已更新”的信号，业务需要时可监听做刷新/提示
            try {
                window.dispatchEvent(
                    new CustomEvent('webconfig:updated', {
                        detail: { oldConfig, newConfig }
                    })
                )
            } catch (e) {
                // ignore
            }
        }

        return { updated: changed, response }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}